import { useMutation } from "@tanstack/react-query";

import { handleMutationError } from "@web-app/utils/errorHandler";

import { useOrdersCache } from "../cache/orders";
import {
  initiateOrderAutoAssign,
  initiateRouteAutoAssign,
} from "../services/autoAssign";

export const useOrderAutoAssign = () => {
  const ordersCache = useOrdersCache();

  const autoAssignOrder = useMutation({
    mutationFn: async (orderId: string) => {
      return initiateOrderAutoAssign(orderId);
    },
    onError: (err: unknown) => {
      handleMutationError(err, "auto-assign order");
    },
    onSuccess: () => {
      ordersCache.invalidateOrdersCache();
    },
  });

  return { autoAssignOrder };
};

export const useRouteAutoAssign = () => {
  const ordersCache = useOrdersCache();

  const autoAssignRoute = useMutation({
    mutationFn: async (routeId: string) => {
      return initiateRouteAutoAssign(routeId);
    },
    onError: (err: unknown) => {
      handleMutationError(err, "auto-assign route");
    },
    onSuccess: () => {
      ordersCache.invalidateOrdersCache();
    },
  });

  return { autoAssignRoute };
};
